import { cn } from "../../lib/utils";
import { badgeVariants } from "./constants";
import { BadgeProps } from "./types";

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, size }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
